export default "__VITE_ASSET__d3cd8936__"